// extracted by mini-css-extract-plugin
export var label = "_bg-1";
export var reminder = "_bg-0";